import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { ClientePJService } from '../../../service/ClientePJService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { CatalogoService } from '../../../service/CatalogoService';
import { Pago } from '../Pago';
import { Tercero } from '../Tercero';
import { OrigenCpj } from '../../../models/cpj/OrigenCpj';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const OrigenLic = ({ toast, catalogos, back, next, id, permss, soloLectura }) => {

  const omodel = new OrigenCpj({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
  const defaultValues = generic.funDefault(omodel.model);
  const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
  const clientepjSrv = new ClientePJService();
  const { inNumber, inText, inArea, inDrop, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
  const [esBeneficiario, setEsBeneficiario] = useState(true);
  const [ecuadorOL, setEcuadorOL] = useState(false);
  const [ciudadesOL, setCiudadesOL] = useState([]);
  const catalogoSrv = new CatalogoService();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [siTercero, setSiTercero] = useState(false);

  useEffect(() => {
    editFicha();
    // eslint-disable-next-line
  }, [id])

  const editFicha = () => {
    setIsLoading(true);
    clientepjSrv.consultarClientepj(id, 'p6', { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
      const cats = catalogos;
      const _clientepj = res.data.clientepj;

      if (res.data.ciudades_ol) {
        setCiudadesOL(res.data.ciudades_ol);
      }

      setEcuadorOL(_clientepj.pais_ol?.cat_id === cats?.ecuador?.cat_id);
      // Verificamos si es Beneficiario o Tercero usando .includes()
      const tipoValorId = _clientepj.tipo_valor_entregado?.cat_id;
      setEsBeneficiario([cats?.ben_final?.cat_id, cats?.tercero?.cat_id].includes(tipoValorId));
      _clientepj.fecha_transaccion = generic.stringToDate(_clientepj.fecha_transaccion);
      reset(generic.renewValues(_clientepj, omodel.model));
    }).finally(() => setIsLoading(false));
  }

  const onSubmit = (data) => {
    setIsSaving(true);
    data.paso = 'p6';
    data.ec = catalogos.ecuador.cat_id;
    if (data.fecha_transaccion) {
      data.fecha_transaccion = data.fecha_transaccion.toISOString().split('T')[0];
    }
    data.id = id;
    data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
    clientepjSrv.editarClientepj(data).then(res => {
      generic.funcSuccess(res, toast);
      next(id);
    }).catch(error => {
      generic.funcError(error, toast, setError);
    }).finally(() => setIsSaving(false));
  }

  const onChangePaisOL = (e) => {
    setEcuadorOL(e.value?.cat_id === catalogos.ecuador?.cat_id);
    setValue('provincia_ol', null);
    setValue('ciudad_ol', null);
    setCiudadesOL([]);
  }

  const onChangeProvinciaOL = (e) => {
    setValue('ciudad_ol', null);
    if (!e?.value) { setCiudadesOL([]); return; }
    catalogoSrv.getCatalogosId(e.value.cat_id).then(res => setCiudadesOL(res.data));
  }

  const onChangeTipoValor = (e) => {
    setEsBeneficiario(JSON.stringify(e.value) === JSON.stringify(catalogos.ben_final) || JSON.stringify(e.value) === JSON.stringify(catalogos.tercero));
  }

  const onError = () => {
    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
  }

  if (isLoading) {
    return (
      <div className="flex flex-column align-items-center justify-content-center p-5">
        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
        <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
      </div>
    );
  }

  const totalTercero = (total) => {
    setSiTercero(total > 0);
  }

  return (
    <>
      <form id="origenLicForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
        <Panel header="PARTE B" className="panel-ficha mb-4">
          <Panel header={generic.renderPanelHeader('B.1', 'ORIGEN LÍCITO DE FONDOS', 'pi pi-money-bill')} className="panel-ficha shadow-1 mb-4">

            <div className="col-12 mb-3">
              <div className="flex align-items-center">
                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                  <i className="pi pi-file-edit text-primary"></i>
                  DATOS DE LA TRANSACCIÓN
                </span>
                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
              </div>
            </div>

            <div className="formgrid grid">
              {inText('transaccion_realiza', { icon: 'pi pi-file' }, catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 12 : 3)}
              {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && inNumber('valor_total_bien_servicio', 2, true, { icon: 'pi pi-dollar' }, 3)}
              {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && inDrop('moneda', catalogos?.moneda, { lab: omodel.optionLabel }, 3)}
              {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && inCalendar('fecha_transaccion', {}, 3)}

              {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && (
                <>
                  {inText('proposito_relacion', { icon: 'pi pi-bookmark' }, 6)}
                  {inText('ubicacion_bien', { icon: 'pi pi-map-marker' }, 6)}
                </>
              )}

              {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && (
                <>
                  {inDrop('pais_ol', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisOL }, ecuadorOL ? 4 : 6)}
                  {ecuadorOL ? (
                    <>
                      {inDrop('provincia_ol', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaOL }, 4)}
                      {inDrop('ciudad_ol', ciudadesOL, { lab: omodel.optionLabel }, 4)}
                    </>
                  ) : (
                    inText('canton_ol', { icon: 'pi pi-map-marker' }, 6)
                  )}
                </>
              )}
            </div>

            {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && (
              <>
                <div className="col-12 mb-3">
                  <div className="flex align-items-center">
                    <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                      <i className="pi pi-wallet text-primary"></i>
                      FORMA DE PAGO
                    </span>
                    <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                  </div>
                </div>
                <Pago toast={toast} tipo={'pj'} id={id} permss={permss} soloLectura={soloLectura} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} />
              </>
            )}

            <div className="col-12 mt-4 mb-3">
              <div className="flex align-items-center">
                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                  <i className="pi pi-money-bill text-primary"></i>
                  ORIGEN DE LOS VALORES
                </span>
                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
              </div>
            </div>

            <div className="formgrid grid">
              {catalogos?.tipoFrmEmpresa !== 'FRM_TOYOTA' && inArea('detalle_act_economica', 3, 100, 6)}
              {inDrop('tipo_valor_entregado', catalogos?.valorEntregado, { lab: omodel.optionLabel, chn: onChangeTipoValor, ne: siTercero ? 'disabled' : '' }, catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 12 : 6)}
            </div>

            {esBeneficiario && (
              <>
                <div className="col-12 mb-3">
                  <div className="flex align-items-center">
                    <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                      <i className="pi pi-users text-primary"></i>
                      BENEFICIARIO FINAL / TERCEROS
                    </span>
                    <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                  </div>
                </div>

                <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-3">
                  <div className="flex align-items-center gap-2 mb-1">
                    <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                    <span className="font-bold text-blue-900">Instrucción</span>
                  </div>
                  En caso de señalar Beneficiario Final o Tercero/s complete la siguiente información:
                </div>
                <Tercero toast={toast} tipo={'pj'} id={id} permss={permss} lista={catalogos} soloLectura={soloLectura} totalTercero={totalTercero} />
              </>
            )}

            {/* DECLARACIÓN TOYOTA */}
            {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && (
              <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mt-3">
                <div className="flex align-items-center gap-2 mb-2">
                  <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                  <span className="font-bold text-blue-900">Declaración</span>
                </div>
                {omodel.declaracion}
              </div>
            )}
          </Panel>
        </Panel>
        <BottomActionBar formId="origenLicForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
      </form>
    </>
  );
}
